<!-- Default mode: simple dialog -->
<div class="modal-dialog-wrap" *ngIf="mode === 'default'">
  <button type="button" class="modal-dialog-close" [attr.aria-label]="closeLabel" (click)="close()">
    <span class="material-symbols-outlined">close</span>
  </button>

  <div class="modal-dialog-icon" *ngIf="icon">
    <span class="material-symbols-outlined">{{ icon }}</span>
  </div>

  <div class="modal-dialog-icon" *ngIf="image">
    <img [src]="image" [alt]="title || 'Icon'">
  </div>

  <h3 class="modal-dialog-title" *ngIf="title">{{ title }}</h3>
  <p class="modal-dialog-message" *ngIf="message">{{ message }}</p>

  <div class="modal-dialog-actions" *ngIf="buttons.length">
    <button *ngFor="let btn of buttons"
            type="button"
            class="modal-dialog-btn"
            [ngClass]="'modal-dialog-btn--' + btn.style"
            (click)="onButton(btn)">
      {{ btn.label }}
    </button>
  </div>
</div>

<!-- Content mode: custom body with header -->
<div class="modal-content-wrap" *ngIf="mode === 'content'">
  <div class="modal-content-header">
    <h3 class="modal-content-title" *ngIf="title">{{ title }}</h3>
    <div class="modal-content-header-actions">
      <button
        *ngFor="let action of headerActions"
        type="button"
        class="modal-dialog-btn modal-dialog-btn--header"
        [ngClass]="'modal-dialog-btn--' + action.style"
        [disabled]="action.loading"
        (click)="onHeaderAction(action)"
      >
        <span *ngIf="!action.loading">{{ action.label }}</span>
        <span *ngIf="action.loading" class="modal-content-spinner"></span>
      </button>
      <button type="button" class="modal-dialog-close modal-dialog-close--inline" [attr.aria-label]="closeLabel" (click)="close()">
        <span class="material-symbols-outlined">close</span>
      </button>
    </div>
  </div>

  <div class="modal-content-body">
    <ng-container *ngIf="contentTemplate" [ngTemplateOutlet]="contentTemplate"></ng-container>
  </div>
</div>
